<template>
  <b-img :src="image" v-bind="$props"></b-img>
</template>

<script>
const axios = require('axios').default;

export default {
  name: 'ProtectedImage',
  props: {
      src: String,   //img endpoint
      fallbackUrl: String,
      reload: Number,

      sizes: {
        type: [String, Array]
        // default: null
      },
      alt: {
        type: String,
        default: null
      },
      width: {
        type: [Number, String]
        // default: null
      },
      height: {
        type: [Number, String]
        // default: null
      },
      block: {
        type: Boolean,
        default: false
      },
      fluid: {
        type: Boolean,
        default: false
      },
      fluidGrow: {
        // Gives fluid images class `w-100` to make them grow to fit container
        type: Boolean,
        default: false
      },
      rounded: {
        // rounded can be:
        //   false: no rounding of corners
        //   true: slightly rounded corners
        //   'top': top corners rounded
        //   'right': right corners rounded
        //   'bottom': bottom corners rounded
        //   'left': left corners rounded
        //   'circle': circle/oval
        //   '0': force rounding off
        type: [Boolean, String],
        default: false
      },
      thumbnail: {
        type: Boolean,
        default: false
      },
      left: {
        type: Boolean,
        default: false
      },
      right: {
        type: Boolean,
        default: false
      },
      center: {
        type: Boolean,
        default: false
      },
      blank: {
        type: Boolean,
        default: false
      },
      blankColor: {
        type: String,
        default: 'transparent'
      }
  },
  watch: { 
    src: function(newVal, oldVal) {
      this.updateImg();
    },
    reload: function(newVal, oldVal) {
      this.updateImg();
    }
  },
  components: {
  },
  data: function () {
      return {
        image: ''
      }
  },
  created() {
    this.updateImg();
  },
  methods: {
    updateImg() {
      if (this.src) {     //lecture depuis le serveur ou depuis un fichier local
        axios.get(this.src, {responseType: 'arraybuffer'})
          .then(response => {
          var mimeType = response.headers['content-type'].toLowerCase();
          var imgBase64 = new Buffer(response.data, 'binary').toString('base64');
          this.image = 'data:' + mimeType + ';base64,' + imgBase64;
          })
      }
      else {       //pas d'image à télécharger, on utilise la fallback img
      }
      this.image = this.fallbackUrl;
    }
  }
}
</script>


<style scoped>

</style>